import { render, staticRenderFns } from "./CommonWaitingList.vue?vue&type=template&id=29807dbc"
import script from "./CommonWaitingList.vue?vue&type=script&lang=js"
export * from "./CommonWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports